import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { OrderThisMonthTitle } from "../../../../../Constants/Constants";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { OrderThisMonthChart } from "../../../../../Data/General/Widgets/General";

const OrderThisMonth = () => {
  return (
    <Col xl="5" sm="6">
      <Card>
        <DashboardCommonHeader title={OrderThisMonthTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <div id="salesReportsLineChart">
            <ReactApexChart options={OrderThisMonthChart} series={OrderThisMonthChart.series} height={305} type="line" />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OrderThisMonth;
